import { GenericError } from '../../../errors/shared/genericError.js';

class LogFilter {
    filters;
    constructor(filters) {
        this.filters = filters;
    }
    approve(error) {
        let message;
        let stack;
        let name;
        if (typeof error === 'string') {
            message = error;
        }
        else if (error instanceof Error || GenericError.isLike(error)) {
            message = error.message;
            stack = error.stack;
            name = error.name;
        }
        else {
            if ('message' in error) {
                message = error.message;
            }
            else {
                message = error.exception_message;
                stack = error.exception;
                name = error.exception_type;
            }
        }
        return !this.filters.some(filter => {
            return (message && filter.test(message)) || (stack && filter.test(stack)) || (name && filter.test(name));
        });
    }
}

export { LogFilter };
//# sourceMappingURL=LogFilter.js.map
